import { useQuery } from '@tanstack/react-query';

export type AdminImportRequestItemShowProvidedJobPost = {
  id: number;
  title: string;
  job_content_json: Array<{ key: string; content?: string }>;
  agent_content_json: Array<{ key: string; content?: string }>;
};

export type AdminImportRequestItemShowCompany = {
  id: number;
  name: string;
};

export type AdminImportRequestItemShow = {
  id: number;
  status: string;
  outer_job_post_id: number;
  organization_id: number;
  job_source_id: number;
  outer_job_post_title: string | null;
  outer_job_post_url: string | null;
  outer_job_post_company_name: string | null;
  outer_job_post_job_content_json: Array<{ key?: string; label?: string; content?: string }> | null;
  outer_job_post_agent_content_json: Array<{
    key?: string;
    label?: string;
    content?: string;
  }> | null;
  created_at: string;
  updated_at: string;
  provided_job_post: AdminImportRequestItemShowProvidedJobPost | null;
  company: AdminImportRequestItemShowCompany | null;
};

export default function useFetchAdminImportRequestItemShow(
  importRequestId: number | null,
  itemId: number | null
) {
  return useQuery({
    queryKey: ['admin', 'import_requests', importRequestId, 'items', itemId],
    queryFn: async () => {
      if (!importRequestId || !itemId) return null;
      const response = await fetch(`/admin/api/import_requests/${importRequestId}/items/${itemId}`);
      if (!response.ok) {
        throw new Error('インポートリクエスト項目の取得に失敗しました');
      }
      const data: AdminImportRequestItemShow = await response.json();
      return data;
    },
    enabled: !!importRequestId && !!itemId,
  });
}
